import React from 'react';
import styled from 'styled-components';
import Card from '../common/Card';
import { FaDatabase, FaSearchLocation, FaCertificate, FaQuestionCircle, FaHeadset, FaEnvelope, FaPhoneAlt, FaArrowRight } from 'react-icons/fa';

// --- STYLED COMPONENTS (com a correção de responsividade) ---

const SectionWrapper = styled(Card)`
  padding: 40px;
  margin: 40px 0;
  &:hover {
    transform: none;
    box-shadow: ${({ theme }) => theme.shadows.sm};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 30px 20px;
  }
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 40px;
  color: ${({ theme }) => theme.colors.primaryDark};
  font-size: 28px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 24px;
  }
`;

const GridContainer = styled.div`
  display: grid;
  gap: 30px;
`;

const HowItWorksGrid = styled(GridContainer)`
  grid-template-columns: repeat(3, 1fr);

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    grid-template-columns: 1fr;
  }
`;

// ==================================================================
// CORREÇÃO DE RESPONSIVIDADE PARA TABLET APLICADA AQUI
// ==================================================================
const SupportGrid = styled(GridContainer)`
  /* Por padrão (desktop), mostra 2 colunas */
  grid-template-columns: repeat(2, 1fr);

  /* Em ecrãs de tablet (e menores), muda para 1 coluna para evitar quebra */
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: 1fr;
  }
`;
// ==================================================================
// FIM DA CORREÇÃO
// ==================================================================

const StepCard = styled.div`
  text-align: center;
  padding: 20px;
  border-radius: ${({ theme }) => theme.radii.md};
  transition: ${({ theme }) => theme.transitions.default};
  
  &:hover {
    transform: translateY(-5px);
    background: #fff;
    box-shadow: ${({ theme }) => theme.shadows.md};
  }
  h3 { margin: 20px 0 15px; color: ${({ theme }) => theme.colors.dark}; }
  p { 
      color: ${({ theme }) => theme.colors.gray}; 
      font-size: 15px; 
      line-height: 1.7; 
      overflow-wrap: break-word;
  }
`;

const StepIcon = styled.div`
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, ${({ theme }) => theme.colors.primary} 0%, ${({ theme }) => theme.colors.accent} 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 32px;
  margin: 0 auto;
  box-shadow: ${({ theme }) => theme.shadows.md};
`;

const SupportCard = styled.div`
  background: ${({ theme }) => theme.colors.light};
  padding: 25px;
  border-radius: ${({ theme }) => theme.radii.md};
  display: flex;
  align-items: flex-start;
  gap: 20px;
  transition: ${({ theme }) => theme.transitions.default};
  border: 1px solid transparent;

  &:hover {
    transform: translateY(-3px);
    box-shadow: ${({ theme }) => theme.shadows.sm};
    border-color: ${({ theme }) => theme.colors.lightGray};
  }
`;

const SupportIcon = styled.div`
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, ${({ theme }) => theme.colors.primary} 0%, ${({ theme }) => theme.colors.accent} 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  flex-shrink: 0;
`;

const SupportContent = styled.div`
  overflow-wrap: break-word;
  word-break: break-word;

  h3 { margin-bottom: 10px; color: ${({ theme }) => theme.colors.primaryDark}; }
  p { color: ${({ theme }) => theme.colors.gray}; font-size: 15px; margin-bottom: 15px; }
`;

const SupportLink = styled.a`
  color: ${({ theme }) => theme.colors.primary};
  font-weight: 600;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: ${({ theme }) => theme.transitions.fast};
  word-break: break-all;

  &:hover {
    color: ${({ theme }) => theme.colors.primaryDark};
  }
`;

// --- COMPONENTE ---

const SupportSection = () => {
    return (
        <>
            <SectionWrapper>
                <Title>Por que nossa consulta é a mais completa?</Title>
                <HowItWorksGrid>
                    <StepCard>
                        <StepIcon><FaDatabase /></StepIcon>
                        <h3>Dados Atualizados</h3>
                        <p>Nossas informações são atualizadas em tempo real diretamente com os órgãos oficiais, garantindo a veracidade dos dados.</p>
                    </StepCard>
                    <StepCard>
                        <StepIcon><FaSearchLocation /></StepIcon>
                        <h3>Análise Profunda</h3>
                        <p>Vamos além da consulta básica, cruzando dados de múltiplas fontes para entregar um relatório completo e confiável.</p>
                    </StepCard>
                    <StepCard>
                        <StepIcon><FaCertificate /></StepIcon>
                        <h3>Validade Jurídica</h3>
                        <p>Nossos relatórios podem ser usados como prova documental em processos judiciais e negociações.</p>
                    </StepCard>
                </HowItWorksGrid>
            </SectionWrapper>

            <SectionWrapper>
                <Title>Precisa de ajuda?</Title>
                <SupportGrid>
                    <SupportCard>
                        <SupportIcon><FaQuestionCircle /></SupportIcon>
                        <SupportContent>
                            <h3>Dúvidas Frequentes</h3>
                            <p>Encontre respostas para as perguntas mais comuns.</p>
                            <SupportLink href="#">Ver FAQ <FaArrowRight /></SupportLink>
                        </SupportContent>
                    </SupportCard>
                    <SupportCard>
                        <SupportIcon><FaHeadset /></SupportIcon>
                        <SupportContent>
                            <h3>Atendimento</h3>
                            <p>Nossa equipe está disponível para ajudar você.</p>
                            <SupportLink href="#">Falar com atendente <FaArrowRight /></SupportLink>
                        </SupportContent>
                    </SupportCard>
                    <SupportCard>
                        <SupportIcon><FaEnvelope /></SupportIcon>
                        <SupportContent>
                            <h3>E-mail de Suporte</h3>
                            <p>Envie suas dúvidas e receba uma resposta em até 24h.</p>
                            <SupportLink href="mailto:suporte@consultaveiculos.com">suporte@consultaveiculos.com</SupportLink>
                        </SupportContent>
                    </SupportCard>
                    <SupportCard>
                        <SupportIcon><FaPhoneAlt /></SupportIcon>
                        <SupportContent>
                            <h3>Telefone</h3>
                            <p>Fale conosco de segunda a sexta, das 9h às 18h.</p>
                            <SupportLink href="tel:1112345678">(61) 4002-8922</SupportLink>
                        </SupportContent>
                    </SupportCard>
                </SupportGrid>
            </SectionWrapper>
        </>
    )
}

export default SupportSection;